import React, {
    useState,
    useEffect,
    useImperativeHandle,
    forwardRef
} from "react";
import { FormSelect } from "shards-react";

export default forwardRef((props, ref) => {
    const [status, setStatus] = useState("default");

    useImperativeHandle(ref, () => {
        return {
            doesFilterPass(params) {
                if (status === "ACTIVE" || status === "INACTIVE") {
                    return params.data.status === status;
                } else {
                    return true;
                }
            },
            isFilterActive() {
                return status !== "default";
            }
        };
    });

    const onStatusChange = event => {
        setStatus(event.target.value);
    };

    useEffect(() => {
        props.filterChangedCallback();
    }, [status]);

    return (
        <FormSelect name="status" id="status" onChange={onStatusChange}>
            <option value={null}>TODOS STATUS</option>
            <option value="INACTIVE">INATIVO</option>
            <option value="ACTIVE">ATIVO</option>
        </FormSelect>
    );
});
